// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__264Jn","tab":"ProcedureTabs_tab__3qqhI"};